import { MessageObjectType } from "../validation/ruleFormSchema";

export enum RuleMessageType {
  INTERNAL = "INTERNAL",
  EXTERNAL = "EXTERNAL",
  EMAIL = "EMAIL",
}

export enum RuleVersionCrudType {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}

export type RuleMessageObjectType = {
  [K in RuleMessageType]: MessageObjectType;
};
